export const API_KEY = 'YOUR_KEY_HERE'



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Maps/API_KEY.js